module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/chefs_choice--xxs@2x-673706c3b7a9fd2b8f07487aaa14b159.png";